import { ArrowRight, Pause } from 'lucide-react'
import { useId } from 'react'
import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import './PurchasePauseNotice.css'

export function PurchasePauseNotice() {
  const messageId = useId()
  return <div className="purchase-pause">
    <div className="purchase-pause__notice" role="status">
      <Pause size={20} aria-hidden="true" />
      <p id={messageId}>RXRouting is not accepting new purchases, please contact <a href="mailto:support@rxrouting.com">support@rxrouting.com</a> for more information.</p>
    </div>
    <button type="button" className="button purchase-pause__next" disabled aria-describedby={messageId}>Next <ArrowRight size={18} aria-hidden="true" /></button>
  </div>
}

export function PurchasePausePage({ publicEntry = false }: { publicEntry?: boolean }) {
  const Container = publicEntry ? 'main' : 'div'
  return <Container className="page page--narrow purchase-pause-page">
    {publicEntry && <Link className="purchase-pause-page__logo" to="/" aria-label="RX Routing home"><Logo /></Link>}
    <header className="page-head"><h1>Purchases are paused.</h1></header>
    <PurchasePauseNotice />
    <p className="purchase-pause-page__return">{publicEntry ? <>Already have an account? <Link to="/login">Sign in</Link></> : <Link to="/dashboard">Back to your orders</Link>}</p>
  </Container>
}
